import { Link } from "@tanstack/react-router";

import type { WorkspaceNavigationItem } from "./workspaceNavigation";

/**
 * Сетка карточек-переходов: иконка, название и описание раздела.
 *
 * Один компонент на «Обзор ERP» и на страницу аккаунта, чтобы оба места
 * выглядели и вели себя одинаково.
 */
export function NavigationCards({
  items,
}: {
  items: readonly WorkspaceNavigationItem[];
}) {
  return (
    <div className="overview-actions">
      {items.map((item) => {
        const Icon = item.icon;

        return (
          <Link key={item.key} className="overview-action" to={item.path}>
            <span className="overview-action__mark" aria-hidden="true">
              <Icon />
            </span>
            <span>
              <strong>{item.label}</strong>
              <small>{item.description}</small>
            </span>
          </Link>
        );
      })}
    </div>
  );
}
